import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCreditCard1"><Path d="M2 4H22V9H2V4Z" fill="currentColor"/><Path d="M2 11V20H22V11H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCreditCard1;
